import { createContext, useContext } from 'react'

/**
 * The shared docs nav, as `{ nav, loading }`.
 *
 * Separate from `DocsNavProvider.jsx` so that file exports a component
 * and nothing else: React Fast Refresh only works on a module whose
 * exports are all components, and a mixed module silently loses hot
 * reloading for the whole docs screen.
 */
const INITIAL = { nav: null, loading: true }

export const DocsNavContext = createContext(INITIAL)

/**
 * Returns the loading placeholder outside a provider rather than
 * throwing: a docs component rendered in isolation (a test, a future
 * embed) should degrade to "no nav yet", not crash.
 */
export function useDocsNavContext() {
    return useContext(DocsNavContext)
}
